import { getLeaderboardApi } from "../services/userService";

export const getLeaderboard = (length, skipPosts, search, courseId, sortBy) => (dispatch) => {
    dispatch(request());
    return getLeaderboardApi(length, skipPosts, search, courseId, sortBy)
        .then((response) => {
            // handle success
            dispatch(success(response));
            return response;
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return { type: "LEADERBOARD_LIST_REQUEST" };
    }

    function success(response) {
        return { type: "LEADERBOARD_LIST_SUCCESS", payload: response };
    }

    function failure(error) {
        return { type: "LEADERBOARD_LIST_FAILURE", payload: error };
    }
};